import { render, staticRenderFns } from "./ShoppingCartOverlay.vue?vue&type=template&id=3332fe34&scoped=true&"
import script from "./ShoppingCartOverlay.vue?vue&type=script&lang=js&"
export * from "./ShoppingCartOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCartOverlay.vue?vue&type=style&index=0&id=3332fe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332fe34",
  null
  
)

export default component.exports